module.exports = __webpack_public_path__ + "static/media/splash.572f80cf.png";